import React, { useEffect, useRef } from "react";
import { Modal } from "antd"; // Using Ant Design Modal
import { useNotification } from "./NotificationContext";
import { notification_sound } from "../../utils/ImagesPath";
import { CURRENCY } from "../../constants/constent";

const NotificationModal = () => {
  const { notification, setNotification } = useNotification();
  const notificationSoundRef = useRef(null);

  useEffect(() => {
    if (notification) {
      notificationSoundRef.current = new Audio(notification_sound);
      notificationSoundRef.current.play();
      // Show the notification modal
      Modal.info({
        title: "New Booking",
        content: (
          <div>
            <h3>Order ID: {notification.order_id}</h3>
            <p>
              Customer Name: <b>{notification.customer_name}</b>
            </p>
            <p>
              Bill Amount:{" "}
              <b>
                {CURRENCY}
                {notification.bill_amt}
              </b>
            </p>
            <p>
              Payment Method: <b>{notification.pay_method ?? "N/A"}</b>
            </p>
            <p>
              Payment Status: <b>{notification.pay_status ?? "N/A"}</b>
            </p>
          </div>
        ),
        onOk() {
          // Stop the sound when "OK" is clicked
          if (notificationSoundRef.current) {
            notificationSoundRef.current.pause();
            notificationSoundRef.current.currentTime = 0; // Reset sound to the beginning
          }
          setNotification(null); // Clear notification after modal close
        },
      });
    }
  }, [notification, setNotification]);

  return null; // This component doesn't render anything itself
};

export default NotificationModal;
